import React from "react";
import { useHooks } from "./hooks";
import { IsochronePluginProps } from "./interfaces";

export const IsochronePlugin = React.memo((props: IsochronePluginProps) => {
  const { map } = useHooks(props);

  if (map) {
    return <></>;
  }

  return null;
});
